<template>
    <card-grid
        ref="grid"
        :button-toolbar-class="[]"
        :is-search="true"
        :key="cardGridKey"
        :pagination="true"
        :fetchCallback="fetchCallback"
        :columnDefs="columnDefs"
        :pagination-page-size="limit"
        :cache-block-size="limit"
        :is-auto-width="true"
        :font-size="tabWidget.settings.table_font_size"
    >
    </card-grid>
</template>

<script>
    import API from '../../../../api';
    import CardGrid from '../../../generic/card-grid/card-grid.vue';
    import GuestCellRenderer from './guest-cell-renderer.vue';
    import CheckOutCellRenderer from './check-out-cell-renderer.vue';
    import StateMarkerCellRenderer from './state-marker-cell-renderer.vue';
    import UserActionsCellRenderer from './staylio-install-base-actions-cell-renderer.vue';

    export default {
        name: 'StaylioInstallBaseCardGrid',
        components: {
            CardGrid,
            guestCellRenderer: GuestCellRenderer,
            checkOutCellRenderer: CheckOutCellRenderer,
            stateMarkerCellRenderer: StateMarkerCellRenderer,
            userActionsCellRenderer: UserActionsCellRenderer,
        },
        props: {
            getDataEndpoint: {
                type: String,
                required: true,
            },
            getDataParams: Object,
            tabWidget: Object,
            cardGridKey: Number,
            limit: Number,
        },
        data() {
            return {
                offset: 0,
                sort: 'guest.id',
                desc: false,
                search: '',
            };
        },
        computed: {
            columnDefs() {
                return [
                    {
                        field: 'guest.id',
                        headerName: '',
                        minWidth: 60,
                    },
                    {
                        field: 'guest.short_name',
                        headerName: 'Guest',
                        minWidth: 200,
                        autoWidthExclude: true,
                    },
                    {
                        field: 'booking_method',
                        headerName: 'Latest Booking Method',
                        minWidth: 200,
                    },
                    {
                        field: 'installed_staylio',
                        headerName: 'Staylio Installed',
                        minWidth: 200,
                    },
                    {
                        headerName: '',
                        minWidth: 100,
                        resizable: false,
                        sortable: false,
                        cellStyle: { textAlign: 'center' },
                        cellRenderer: 'userActionsCellRenderer',
                        cellRendererParams: {},
                    },
                ];
            },
            fetchCallback() {
                return ({ offset, sort, desc, search }) => {
                    this.offset = offset;
                    this.sort = sort;
                    this.desc = desc;
                    this.search = search;
                    return API.get(this.getDataEndpoint, {
                        params: {
                            ...this.getDataParams,
                            limit: this.limit,
                            offset: this.offset,
                            desc: this.desc,
                            sort: this.sort,
                            search: this.search,
                        },
                    });
                };
            },
        },
    };
</script>
